import * as Yup from 'yup'

import { makeTemplateValidation } from './helpers'

export const makeEmailValidationSchema = (t) => {
  const templateValidation = makeTemplateValidation(t)
  return Yup.object().shape({
    title: templateValidation.requiredString,
    from: templateValidation.requiredString,
    replyTo: templateValidation.email,
    testEmail: templateValidation.email,
  })
}

export const makeNotificationValidationSchema = (t) => {
  const templateValidation = makeTemplateValidation(t)
  return Yup.object().shape({
    title: templateValidation.requiredString.max(
      50,
      t('organisation:communicationPortal.validation.maxCharacters', { count: 50 }),
    ),
    from: templateValidation.requiredString,
    message: Yup.string().max(
      2500,
      t('organisation:communicationPortal.validation.maxCharacters', { count: 2500 }),
    ),
  })
}

export const makeSmsValidationSchema = (t) => {
  const templateValidation = makeTemplateValidation(t)
  return Yup.object().shape({
    sendTo: templateValidation.requiredString,
    message: templateValidation.requiredString,
  })
}
